import { Component, Input, OnInit } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ILEitherLocation, ILSessionState } from '@models/instructor-led';
import { IlLocationTypeEnum } from '@queries/generated';
import { iconForLocation } from '@util/icon-for-il-location';

@Component({
  selector: 'vnm-il-session-location',
  templateUrl: './il-session-location.component.html',
  styleUrls: ['./il-session-location.component.scss']
})
export class IlSessionLocationComponent implements OnInit {
  IlLocationTypeEnum = IlLocationTypeEnum;

  @Input() hideLocationUrl = false;
  @Input() location: ILEitherLocation;
  @Input() set sessionState(state: ILSessionState) {
    if (state && state !== ILSessionState.Active) {
      this.stateMessage = `il-session-location.session-state.${state}`;
    } else {
      this.stateMessage = null;
    }
  }

  stateMessage: string;
  locationIcon: IconProp;

  ngOnInit() {
    this.locationIcon = iconForLocation(this.location);
  }
}
